export default __webpack_public_path__ + "static/media/alfa_fin.0123158d.svg";